import { styled } from "@mui/system";

export const MainContainer = styled("div")({
    width: "50rem",
    maxWidth: "100%",
    textAlign: "center",
});
